import React, { useState, useRef, useMemo, useEffect } from 'react';
import JoditEditor from 'jodit-react';
import { useParams } from 'react-router-dom';

const AdministratorJoditEditor = ({ placeholder, subTitle,editorContent, onContentChange }) => {
  const {id} = useParams();
	const editor = useRef(null);
	const [content, setContent] = useState('');


	const insertDefault = (subTitle) => {
		let tableHtml = '';
		if(subTitle === "staffSelfSupporting"){
			tableHtml=`<p>Left the services</p><table style="border-collapse:collapse;width: 100%;"><tbody>
			<tr>
				<td style="width: 20%;">S.No</td>
				<td style="width: 20%;">Name and Designation</td>
				<td style="width: 20%;">Department</td>
				<td style="width: 20%;">Relieved on</td>
				<td style="width: 20%;">Date of joining</td>

			<tr>
				<td style="width: 20%;">1</td>
				<td style="width: 20%;"></td>
				<td style="width: 20%;"></td>
				<td style="width: 20%;"></td>
				<td style="width: 20%;"></td></tr></tbody></table><p>Appointments</p><table style="border-collapse:collapse;width: 100%;"><tbody>
			<tr>
				<td style="width: 20%;">S.No</td>
				<td style="width: 20%;">Name and Designation</td>
				<td style="width: 20%;">Department</td>				
				<td style="width: 20%;">Date of joining</td>
				<td style="width: 20%;">Nature of Appointment</td>

			<tr>
				<td style="width: 20%;">1</td>
				<td style="width: 20%;"></td>
				<td style="width: 20%;"></td>
				<td style="width: 20%;"></td>
				<td style="width: 20%;"></td></tr></tbody></table><p>Extension of temporary Appointments</p><table style="border-collapse:collapse;width: 100%;"><tbody>
			<tr>
				<td style="width: 20%;">S.No</td>
				<td style="width: 20%;">Name and Designation</td>
				<td style="width: 20%;">Department</td>				
				<td style="width: 20%;">Date of first appointment</td>
				<td style="width: 20%;">Appointment till extension</td>

			<tr>
				<td style="width: 20%;">1</td>
				<td style="width: 20%;"></td>
				<td style="width: 20%;"></td>
				<td style="width: 20%;"></td>
				<td style="width: 20%;"></td></tr></tbody></table><p>Regularization of Appointments</p><table style="border-collapse:collapse;width: 100%;"><tbody>
			<tr>
				<td style="width: 25%;">S.No</td>
				<td style="width: 25%;">Name and Designation</td>
				<td style="width: 25%;">Department</td>				
				<td style="width: 25%;">Date of regularization of appointment</td>
			<tr>
				<td style="width: 25%;">1</td>
				<td style="width: 25%;"></td>
				<td style="width: 25%;"></td>
				<td style="width: 25%;"></td></tr></tbody></table><p>Confirmation of Service</p><table style="border-collapse:collapse;width: 100%;"><tbody>
			<tr>
				<td style="width: 20%;">S.No</td>
				<td style="width: 20%;">Name and Designation</td>
				<td style="width: 20%;">Department</td>				
				<td style="width: 20%;">Date of regularization</td>
				<td style="width: 20%;">Date of confirmation</td>

			<tr>
				<td style="width: 20%;">1</td>
				<td style="width: 20%;"></td>
				<td style="width: 20%;"></td>
				<td style="width: 20%;"></td>
				<td style="width: 20%;"></td></tr></tbody></table><p>Appointments (External Candidates)</p><table style="border-collapse:collapse;width: 100%;"><tbody>
			<tr>
				<td style="width: 20%;">S.No</td>
				<td style="width: 20%;">Name</td>
				<td style="width: 20%;">Recommendation for the post of</td>				
				<td style="width: 20%;">Department</td>
				<td style="width: 20%;">Date of joining</td>

			<tr>
				<td style="width: 20%;">1</td>
				<td style="width: 20%;"></td>
				<td style="width: 20%;"></td>
				<td style="width: 20%;"></td>
				<td style="width: 20%;"></td></tr></tbody></table><p>Appointments/Promotion Internal Candidates</p><table style="border-collapse:collapse;width: 100%;"><tbody>
			<tr>
				<td style="width: 20%;">S.No</td>
				<td style="width: 20%;">Name</td>
				<td style="width: 20%;">Designation</td>				
				<td style="width: 20%;">Department</td>
				<td style="width: 20%;">With effect from</td>

			<tr>
				<td style="width: 20%;">1</td>
				<td style="width: 20%;"></td>
				<td style="width: 20%;"></td>
				<td style="width: 20%;"></td>
				<td style="width: 20%;"></td></tr></tbody></table><p>Career Advancement to teaching staff</p><table style="border-collapse:collapse;width: 100%;"><tbody>
			<tr>
				<td style="width: 20%;">S.No</td>
				<td style="width: 20%;">Name and present designation</td>
				<td style="width: 20%;">Department</td>
				<td style="width: 20%;">Upward movement under career advancement scheme</td>	
				<td style="width: 20%;">Date of joining for the upward movement</td>

			<tr>
				<td style="width: 20%;">1</td>
				<td style="width: 20%;"></td>
				<td style="width: 20%;"></td>
				<td style="width: 20%;"></td>
				<td style="width: 20%;"></td></tr></tbody></table><p>Retirement on Superannuation</p><table style="border-collapse:collapse;width: 100%;"><tbody>
			<tr>
				<td style="width: 20%;">S.No</td>
				<td style="width: 20%;">Name and designation</td>
				<td style="width: 20%;">Department</td>
				<td style="width: 20%;">Date of birth</td>	
				<td style="width: 20%;">Date of Superannuation</td>

			<tr>
				<td style="width: 20%;">1</td>
				<td style="width: 20%;"></td>
				<td style="width: 20%;"></td>
				<td style="width: 20%;"></td>
				<td style="width: 20%;"></td></tr></tbody></table><p>Retirement on Superannuation and Re-Employment</p><table style="border-collapse:collapse;width: 100%;"><tbody>
			<tr>
				<td style="width: 20%;">S.No</td>
				<td style="width: 20%;">Name and designation and department</td>
				<td style="width: 20%;">Date of birth</td>
				<td style="width: 20%;">Date of Superannuation</td>
				<td style="width: 20%;">Re-appointment from</td>
			<tr>
				<td style="width: 20%;">1</td>
				<td style="width: 20%;"></td>
				<td style="width: 20%;"></td>
				<td style="width: 20%;"></td>
				<td style="width: 20%;"></td></tr></tbody></table><p>Salary enhancement teaching staff (if any)</p><br><p>Salary revision Non teaching staff (if any)</p>`
		} else if(subTitle === "staffGrantInAid"){
			tableHtml=`<p>Retired on Superannuation</p><table style="border-collapse:collapse;width: 100%;"><tbody>
			<tr>
				<td style="width: 25%;">S.No</td>
				<td style="width: 25%;">Name and Designation</td>
				<td style="width: 25%;">Department</td>				
				<td style="width: 25%;">Date of retirement</td>
			<tr>
				<td style="width: 25%;">1</td>
				<td style="width: 25%;"></td>
				<td style="width: 25%;"></td>
				<td style="width: 25%;"></td></tr></tbody></table><p>Regularization of appointment</p><table style="border-collapse:collapse;width: 100%;"><tbody>
			<tr>
				<td style="width: 25%;">S.No</td>
				<td style="width: 25%;">Name and Designation</td>
				<td style="width: 25%;">Department</td>				
				<td style="width: 25%;">Date of regularization</td>
			<tr>
				<td style="width: 25%;">1</td>
				<td style="width: 25%;"></td>
				<td style="width: 25%;"></td>
				<td style="width: 25%;"></td></tr></tbody></table><p>Confirmation of Service</p><table style="border-collapse:collapse;width: 100%;"><tbody>
			<tr>
				<td style="width: 25%;">S.No</td>
				<td style="width: 25%;">Name and Designation</td>
				<td style="width: 25%;">Department</td>				
				<td style="width: 25%;">Date of confirmation</td>
			<tr>
				<td style="width: 25%;">1</td>
				<td style="width: 25%;"></td>
				<td style="width: 25%;"></td>
				<td style="width: 25%;"></td></tr></tbody></table><p>Superannuation-Teaching staff-Retirement in the middle of the academic year-Re-employment-Reg</p><table style="border-collapse:collapse;width: 100%;"><tbody>
			<tr>
				<td style="width: 20%;">S.No</td>
				<td style="width: 20%;">Name and designation and department</td>
				<td style="width: 20%;">Date of birth</td>
				<td style="width: 20%;">Date of Superannuation</td>
				<td style="width: 20%;">Re-Employment period</td>
			<tr>
				<td style="width: 20%;">1</td>
				<td style="width: 20%;"></td>
				<td style="width: 20%;"></td>
				<td style="width: 20%;"></td>
				<td style="width: 20%;"></td></tr></tbody></table><p>Award of cash incentive to the employees who have ended 25 years of unblemished service</p><table style="border-collapse:collapse;width: 100%;"><tbody>
			<tr>
				<td style="width: 20%;">S.No</td>
				<td style="width: 20%;">Name of staff</td>
				<td style="width: 20%;">Designation</td>
				<td style="width: 20%;">Department</td>
				<td style="width: 20%;">Date of completion of 25 years of service</td>
			<tr>
				<td style="width: 20%;">1</td>
				<td style="width: 20%;"></td>
				<td style="width: 20%;"></td>
				<td style="width: 20%;"></td>
				<td style="width: 20%;"></td></tr></tbody></table>`
		} else if (subTitle === "aicteApproval") {
			setContent("");
		}
		setContent(tableHtml)
	};

	const insertImage = (resp) => {
		const imageUrl = `${process.env.REACT_APP_BASE_URL}/api/object/${resp.id}`;
		const imgHtml = `<img src="${imageUrl}" alt="Image" style="max-width: 100%; height: auto;" />`;
		const currentContent = editor.current?.value || content;  
		const updatedContent = currentContent + imgHtml;
		setContent(updatedContent);
		onContentChange(updatedContent);
	};


	// Memoized configuration for JoditEditor
	
	const config = useMemo(() => ({
		readonly: false,
		placeholder: placeholder || '',
		toolbar: {
			buttons: [
				'bold',
				'italic',
				'underline',
				'image', // Include the image button
				'|', // Divider
				'source',
			],
		},uploader: {
			insertImageAsBase64URI: false,
			url: `${process.env.REACT_APP_BASE_URL}/api/report/${id}/upload`,
			headers: {
				Authorization: `Bearer ${localStorage.getItem("jwt")}`
			},
			method: 'POST',
			prepareData: (formData) => {
				const files = formData.getAll('files[0]'); 
				formData.delete('files[0]'); 
			
				files.forEach((file) => {
					formData.append('file', file); 
				});
				return formData;
			}
			,
			isSuccess: (resp) => {
				return resp;
			},
			process: (resp) => {
				console.log('File uploaded successfully:', resp);
				insertImage(resp)
				return {}; 
			},
			error: (e) => {
				console.error('Upload error', e);
			}
		},
		events: {
			beforeImage: function(current) {
				return false; 
			},
			'errorMessage': function(message) {
				console.error(message);
			}
		}
	}), [placeholder, id]);

	useEffect(() => {
		if (!editorContent) {
			insertDefault(subTitle);
		} else{
			setContent(editorContent);
		}
	}, [subTitle]);

	const handleContentChange = (newContent) => {
		setContent(newContent);
		onContentChange(newContent);
	  };

	return (
		<JoditEditor
			ref={editor}
			value={content}
			config={config}
			tabIndex={1}
			onBlur={(newContent) => handleContentChange(newContent)}
			onChange={(newContent) => {}}
		/>
	);
};

export default AdministratorJoditEditor;
